import { useState, useEffect } from 'react'
import { toast } from 'react-toastify';

export const useFetchAllLegalDocuments = ({marvarApi, dispatch, onLogout}) => {

    // 1. Para los datos recuperados de la BD
    const [dataLegalDocuments, setDataLegalDocuments] = useState([])
    
    // 2. Para mostrar animación de carga
    const [ loadingFetchAllLegalDocuments, setLoadingFetchAllLegalDocuments ] = useState(false)

    // 3. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            
            const response = await marvarApi.get(`/legal-notarial/fetch-all-legal-documents`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        setLoadingFetchAllLegalDocuments(true)
        fetchData()
            .then((resp) => {
                setDataLegalDocuments(resp.rows)
                setLoadingFetchAllLegalDocuments(false)
            })
            .catch(e => {
                console.log(e, '________ERROR')
                setLoadingFetchAllLegalDocuments(false)
            })
    }, [execute])

    return { dataLegalDocuments, loadingFetchAllLegalDocuments, executeFetch }

}

export const useFetchSpecificLegalDocument = ({marvarApi, dispatch, onLogout, Forms}) => {

    // 1. Para los datos recuperados de la BD
    // const [infoClient, setInfoClient] = useState([])
    const { FormScreen } = Forms
    const { formState, setFormState } = FormScreen
    
    // 2. Para mostrar animación de carga
    const [ loadingFetchSpecificLegalDocument, setLoadingFetchSpecificLegalDocument ] = useState(false)

    // 3. Para setear parametros de búsqueda al fetch
    const [paramsToSearch, setParamsToSearch] = useState({iddocument: ''})

    // 4. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        try {
            
            const response = await marvarApi.get(`/legal-notarial/fetch-specific-legal-documents/${paramsToSearch.iddocument}`)
            console.log('[useFetchData][useFetchSpecificLegalDocument] response.data ', response.data)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if(paramsToSearch.iddocument > 0 ){
            setLoadingFetchSpecificLegalDocument(true)
            fetchData()
                .then((resp) => {
                    
                    // Setea en el estado del formulario los datos del registro
                    const { rows } = resp
                    setFormState((prevState) => ({
                        ...prevState,
                        iddocument: rows[0].iddocument || '',
                        idprocesstype: rows[0].idprocesstype || '',
                        idlawyer: rows[0].idlawyer || '',
                        date_document: rows[0].date_document || '',
                        observations: rows[0].observations || ''
                    }))
                    setLoadingFetchSpecificLegalDocument(false)

                })
                .catch(e => {
                    console.log(e, '________ERROR')
                    setLoadingFetchSpecificLegalDocument(false)
                })
        }
    }, [execute])

    return { loadingFetchSpecificLegalDocument, setParamsToSearch, executeFetch }

}

export const useFetchProcessType = ({marvarApi, dispatch, onLogout}) => {

    // 1. Para los datos recuperados de la BD
    const [dataProcessType, setDataProcessType] = useState([])
    
    // 2. Para mostrar animación de carga
    const [ loadingFetchProcessType, setLoadingFetchProcessType ] = useState(false)

    // 3. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            
            const response = await marvarApi.get(`/legal-notarial/fetch-process-type-for-legal-documents`)
            // console.log('[useFetchData][useFetchProcessType] response.data ', response.data)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        setLoadingFetchProcessType(true)
        fetchData()
            .then((resp) => {
                setDataProcessType(resp.rows)
                setLoadingFetchProcessType(false)
            })
            .catch(e => {
                console.log(e, '________ERROR')
                setLoadingFetchProcessType(false)
            })
    }, [execute])

    return { dataProcessType, loadingFetchProcessType, executeFetch }

}

export const useFetchProcessLawyer = ({marvarApi, dispatch, onLogout}) => {

    // 1. Para los datos recuperados de la BD
    const [dataProcessLawyer, setDataProcessLawyer] = useState([])
    
    // 2. Para mostrar animación de carga
    const [ loadingFetchProcessLawyer, setLoadingFetchProcessLawyer ] = useState(false)

    // 3. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            
            const response = await marvarApi.get(`/legal-notarial/fetch-process-reference-for-legal-documents`)
            // console.log('[useFetchData][useFetchProcessLawyer] response.data ', response.data)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        setLoadingFetchProcessLawyer(true)
        fetchData()
            .then((resp) => {
                setDataProcessLawyer(resp.rows)
                setLoadingFetchProcessLawyer(false)
            })
            .catch(e => {
                console.log(e, '________ERROR')
                setLoadingFetchProcessLawyer(false)
            })
    }, [execute])

    return { dataProcessLawyer, loadingFetchProcessLawyer, executeFetch }

}

export const useFetchAllDocumentsStamps = ({marvarApi, dispatch, onLogout}) => {

    const [paramsToSearch, setParamsToSearch] = useState({iddocument: ''})

    // 1. Para los datos recuperados de la BD
    const [ dataDocumentsStamps, setDataDocumentsStamps ] = useState([])
    
    // 2. Para mostrar animación de carga
    const [ loadingFetchAllDocumentsStamps, setLoadingFetchAllDocumentsStamps ] = useState(false)

    // 3. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            
            const response = await marvarApi.get(`/legal-notarial/fetch-all-documents-stamps/${paramsToSearch.iddocument}`)
            console.log('[useFetchData][useFetchAllDocumentsStamps] response.data ', response.data)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if(paramsToSearch.iddocument > 0 ){
            setLoadingFetchAllDocumentsStamps(true)
            fetchData()
                .then((resp) => {
                    setDataDocumentsStamps(resp.rows)
                    setLoadingFetchAllDocumentsStamps(false)
                })
                .catch(e => {
                    console.log(e, '________ERROR')
                    setLoadingFetchAllDocumentsStamps(false)
                })
        }
    }, [execute])

    return { dataDocumentsStamps, loadingFetchAllDocumentsStamps, setParamsToSearch, executeFetch }

}

export const useFetchSpecificDocumentsStamps = ({marvarApi, dispatch, onLogout, Forms}) => {

    // 1. Para los datos recuperados de la BD
    // const [infoClient, setInfoClient] = useState([])
    const { FormStamps } = Forms
    const { formState, setFormState } = FormStamps
    
    // 2. Para mostrar animación de carga
    const [ loadingFetchSpecificDocumentsStamps, setLoadingFetchSpecificDocumentsStamps ] = useState(false)

    // 3. Para setear parametros de búsqueda al fetch
    const [paramsToSearch, setParamsToSearch] = useState({iddocumentsstamps: ''})

    // 4. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        try {
            
            const response = await marvarApi.get(`/legal-notarial/fetch-specific-documents-stamps/${paramsToSearch.iddocumentsstamps}`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if(paramsToSearch.iddocumentsstamps > 0 ){
            setLoadingFetchSpecificDocumentsStamps(true)
            fetchData()
                .then((resp) => {
                    
                    // Setea en el estado del formulario los datos del registro
                    const { rows } = resp
                    setFormState((prevState) => ({
                        ...prevState,
                        iddocumentstamps: rows[0].iddocumentstamps ||'',
                        iddocument: rows[0].iddocument ||'',
                        idstamp: rows[0].idstamp ||'',
                        quantity: rows[0].quantity ||''
                    }))
                    setLoadingFetchSpecificDocumentsStamps(false)

                })
                .catch(e => {
                    console.log(e, '________ERROR')
                    setLoadingFetchSpecificDocumentsStamps(false)
                })
        }
    }, [execute])

    return { loadingFetchSpecificDocumentsStamps, setParamsToSearch, executeFetch }

}

export const useFetchStamps = ({marvarApi, dispatch, onLogout}) => {

    // 1. Para los datos recuperados de la BD
    const [dataStamps, setDataStamps] = useState([])
    
    // 2. Para mostrar animación de carga
    const [ loadingFetchStamps, setLoadingFetchStamps ] = useState(false)

    // 3. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            
            const response = await marvarApi.get(`/legal-notarial/fetch-stamps`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        setLoadingFetchStamps(true)
        fetchData()
            .then((resp) => {
                setDataStamps(resp.rows)
                setLoadingFetchStamps(false)
            })
            .catch(e => {
                console.log(e, '________ERROR')
                setLoadingFetchStamps(false)
            })
    }, [execute])

    return { dataStamps, loadingFetchStamps, executeFetch }

}